import React, { forwardRef } from 'react'
import LabelTailwind from './Label'
import { isLexusCss } from 'utils/utils'

const sanitizeId = (label: string) => label.toLowerCase().replace(/\s+/g, '-');

  let urlisLexus = []
  let url = window.location.href;
  isLexusCss(url).then(isLexus => {
    urlisLexus=isLexus
  })

const Input = (
  {
    cssProps,
    customLabel,
    customCssPropsLabel,
    error,
    name,
    type,
    onBlur,
    register,
    validationOptions = {},
    ...rest
  },
  _ref,
) => {
  const inputId = customLabel ? sanitizeId(customLabel) : name;
  const errorId = `${name}-error`;
  return (
    <>
      {customLabel && (
        <div className="mb-2">
          <LabelTailwind cssProps={customCssPropsLabel} name={customLabel} htmlFor={inputId}/>
        </div>
      )}
      <div>
        <input
          id={inputId}
          {...register(name, { ...validationOptions })}
          {...rest}
          type={type}
          className={ cssProps ?? `border-2 rounded w-full h-12 px-2 font-${urlisLexus[0]} text-primary`}
          name={name}
          onBlur={onBlur}
          aria-describedby={error ? errorId : undefined}
          aria-invalid={!!error}
          aria-required="true"
        />
      </div>
      {error && (
        <div className="mb-2" role="alert" id={errorId}>
          <LabelTailwind
            id={errorId}
            name={error?.message}
            cssProps={`text-third font-${urlisLexus[0]}`}
          />
        </div>
      )}
    </>
  )
}

export default forwardRef(Input)
